/**
 * TanStack Query hooks for `igaming-multi-currency-invoice-generation`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	igamingMultiCurrencyInvoiceGenerationQueryKeys,
	type CreateIgamingMultiCurrencyInvoiceGenerationBody,
	type ListIgamingMultiCurrencyInvoiceGenerationResponse,
	type IgamingMultiCurrencyInvoiceGenerationRow,
} from "./api";

export function useIgamingMultiCurrencyInvoiceGenerationList(): UseQueryResult<ListIgamingMultiCurrencyInvoiceGenerationResponse, Error> {
	return useQuery({
		queryKey: igamingMultiCurrencyInvoiceGenerationQueryKeys.list(),
		queryFn: list,
	});
}

export function useIgamingMultiCurrencyInvoiceGenerationCreate(): UseMutationResult<IgamingMultiCurrencyInvoiceGenerationRow, Error, CreateIgamingMultiCurrencyInvoiceGenerationBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingMultiCurrencyInvoiceGenerationQueryKeys.all });
		},
	});
}

export function useIgamingMultiCurrencyInvoiceGenerationDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingMultiCurrencyInvoiceGenerationQueryKeys.all });
		},
	});
}
